import firebase from 'firebase';
let UserFactory = function($firebaseAuth, $firebaseObject, $firebaseStorage, $firebaseArray, SERVERURL, $http) {
  "ngInject";
  const user = {};
  let ref = firebase.database().ref();
  let Auth = $firebaseAuth(firebase.auth());

  let getUser = () => {
    return user;
  };

  let isSignedIn = () => {
    return user.isSignedIn;
  };

  let signup = (email, password) => {
    return Auth.$createUserWithEmailAndPassword(email, password);
  };
  let login = (email, password) => {
    return Auth.$signInWithEmailAndPassword(email, password);
  }
  let logout = () => {
    return Auth.$signOut();
  }

  let sendPasswordResetEmail = (email) => {
    return Auth.$sendPasswordResetEmail(email);
  }

  let getToken = () => {
    return firebase.auth().currentUser._lat;
  }

  let getUserId = () => {
    let userId = Auth.$getAuth().uid;
    return userId;
  }

  let getUserEmail = () => {
    let email = Auth.$getAuth().email;
    return email;
  }

  let updateUserInFb = () => {
    let userId = Auth.$getAuth().uid;
    let emailId = Auth.$getAuth().email;
    let item = {
      userId,
      emailId,
    };
    return firebase.database().ref('/users_meta/' + userId).update(item);
  }

  let getUserSettings = () => {
    let userId = Auth.$getAuth().uid;
    return $firebaseObject(firebase.database().ref('user_settings').child(userId));
  }


  let getUserPlans = () => {
    let userId = Auth.$getAuth().uid;
    return $firebaseObject(firebase.database().ref('user_plans').child(userId));
  }

  let updateUserOnboarding = (data) => {
    let userId = Auth.$getAuth().uid;
    return firebase.database().ref('user_onboarding').child(userId).update(data);
  }


  let getUserOnboarding = (data) => {
    let userId = Auth.$getAuth().uid;
    return $firebaseObject(firebase.database().ref('user_onboarding').child(userId));
  }

  let connectTwitter = () => {
    return $http.get(`${SERVERURL}twitter/auth`);
  }

  let connectHelpscout = (apiKey) => {
    return $http.post(`${SERVERURL}helpscout/auth`, {
      apiKey
    });
  }

  let getHelpscoutMailbox = () => {
    return $http.get(`${SERVERURL}helpscout/mailboxes`);
  }

  let saveMailbox = (data) => {
    return $http.post(`${SERVERURL}helpscout/mailboxes`, data);
  }

  let getFacebookSettings = () => {
    let userId = Auth.$getAuth().uid;
    return $firebaseObject(firebase.database().ref('facebook_users').child(userId));
  }

  let getHelpscoutSettings = () => {
    let userId = Auth.$getAuth().uid;
    return $firebaseObject(firebase.database().ref('helpscout_users').child(userId));
  }


  let getTwitterSettings = () => {
    let userId = Auth.$getAuth().uid;
    return $firebaseArray(firebase.database().ref('twitter_settings').child(userId));
  }

  let updateTwitterSettings = (newData) => {
    let userId = Auth.$getAuth().uid;
    return firebase.database().ref('twitter_settings').child(userId).set(newData);
  }

  let connectFacebook = () => {
    return $http.get(`${SERVERURL}facebook/auth`);
  }

  let getFacebookPages = () => {
    return $http.get(`${SERVERURL}facebook/pages`);
  }

  let saveFacebookPage = (data) => {
    return $http.post(`${SERVERURL}facebook/pages`, data);
  }


  let processPayment = (data) => {
    return $http.post(`${SERVERURL}plans/process`, data);
  }

  let revokeFacebook = () => {
    return $http.post(`${SERVERURL}facebook/revoke`, {});
  }

  let revokeTwitter = () => {
    return $http.post(`${SERVERURL}twitter/revoke`, {});
  }

  let getCards = () => {
    return $http.get(`${SERVERURL}plans/cards`);
  }

  let updateCard = (token) => {
    return $http.post(`${SERVERURL}plans/card`, {
      token
    });
  }
  let changePlans = (plan) => {
    return $http.post(`${SERVERURL}plans/change`, {
      plan
    });
  }

  let deactivateSubscription = () => {
    return $http.post(`${SERVERURL}plans/cancel`, {});
  }




  return {
    isSignedIn,
    signup,
    login,
    sendPasswordResetEmail,
    logout,
    getUserEmail,
    getToken,
    updateUserInFb,
    getUserId,
    connectTwitter,
    connectHelpscout,
    getUserSettings,
    getTwitterSettings,
    updateTwitterSettings,
    connectFacebook,
    getFacebookPages,
    saveFacebookPage,
    getHelpscoutMailbox,
    saveMailbox,
    processPayment,
    updateUserOnboarding,
    getUserPlans,
    revokeFacebook,
    revokeTwitter,
    updateCard,
    getCards,
    changePlans,
    deactivateSubscription,
    getUserOnboarding,
    getFacebookSettings,
    getHelpscoutSettings
  };
};

export default UserFactory;



// WEBPACK FOOTER //
// ./client/app/common/user/user.factory.js